const React = require("react");
const T = require("prop-types");
const FlatButton = require("material-ui/FlatButton").default;
const RaisedButton = require("material-ui/RaisedButton").default;
const Classes = require("./styles.scss");
const NavLink = require("react-router-dom").NavLink;
const EditIcon = require("material-ui/svg-icons/image/edit").default;
const ShoppingCartIcon = require("material-ui/svg-icons/action/shopping-cart")
    .default;
const DeleteIcon = require("material-ui/svg-icons/action/delete").default;
const TransactionDialog = require("containers/TransactionDialog");
const DeleteConfirmDialog = require("components/Dialog/DeleteConfirmDialog");
const { previewImageLink } = require("utils/asset-api");
const WhatsIncludedDialog = require("containers/WhatsIncludedDialog");

const internals = {};

internals.renderDate = dateString => {
    const date = new Date(dateString);

    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();

    return month + "/" + day + "/" + year;
};

module.exports = class BodyModelPreview extends React.Component {
    static propTypes = {
        token: T.string.isRequired,
        fetchData: T.func.isRequired,
        onDeleteClick: T.func.isRequired,
        onPurchaseClick: T.func.isRequired,
        onSeeWhatsIncluded: T.func.isRequired,
        croquis: T.shape({
            id: T.number.isRequired,
            title: T.string.isRequired,
            dateModified: T.string.isRequired,
            dateCreated: T.string.isRequired,
            measurements: T.object.isRequired // Required indirectly by previewImageLink from asset-api
        }),
        match: T.object
    };

    state = {
        isDeleteConfirmDialogOpen: false
    };

    componentDidMount() {
        const { croquis, fetchData } = this.props;

        window.scrollTo(0, 0);

        if (typeof croquis === "undefined") {
            fetchData(this.props.match.params.id);
        }
    }

    handleOpenDeleteConfirmDialog = () => {
        this.setState({ isDeleteConfirmDialogOpen: true });
    };

    handleCloseDeleteConfirmDialog = () => {
        this.setState({ isDeleteConfirmDialogOpen: false });
    };

    render() {
        const {
            croquis,
            onDeleteClick,
            onPurchaseClick,
            onSeeWhatsIncluded
        } = this.props;

        const { isDeleteConfirmDialogOpen } = this.state;

        if (typeof croquis === "undefined") {
            return <div>No Body Model found!</div>;
        }

        return (
            <div>
                <div className={Classes.croquisRender}>
                    <h1>Your Body Model Preview</h1>
                    <h2>{croquis.title}</h2>
                    <p>
                        Saved:{" "}
                        {internals.renderDate(
                            croquis.dateModified || croquis.dateCreated
                        )}
                    </p>
                    <div
                        className={Classes.croquisContainer}
                        style={{
                            backgroundImage: `url(${previewImageLink(
                                croquis,
                                "draft",
                                this.props.token
                            )}`
                        }}
                    />
                    <hr />
                    <div className={Classes.buttonContainer}>
                        <div className={Classes.buttonGroup}>
                            <RaisedButton
                                label="Purchase"
                                primary
                                onClick={() => onPurchaseClick(croquis.id)}
                                icon={<ShoppingCartIcon />}
                                labelStyle={{
                                    textTransform: "inherit"
                                }}
                            />
                        </div>
                        <div className={Classes.buttonGroup}>
                            <RaisedButton
                                label="Edit"
                                containerElement={
                                    <NavLink
                                        to={`/body-model/${croquis.id}/edit`}
                                    />
                                }
                                icon={<EditIcon />}
                                labelStyle={{
                                    textTransform: "inherit"
                                }}
                            />
                            <RaisedButton
                                label="Delete"
                                icon={<DeleteIcon />}
                                labelStyle={{
                                    textTransform: "inherit"
                                }}
                                onClick={this.handleOpenDeleteConfirmDialog}
                            />
                        </div>
                    </div>
                    <div className={Classes.buttonContainer}>
                        <div className={Classes.buttonGroup}>
                            <FlatButton
                                primary
                                label={"See What's Included"}
                                onClick={onSeeWhatsIncluded}
                                className={Classes.menuOptionsDesktop}
                                labelStyle={{ textTransform: "inherit" }}
                            />
                        </div>
                    </div>
                </div>
                <hr />
                <div className={Classes.betaBanner}>
                    <p>
                        Click &quot;Edit&quot; to adjust your measurements and
                        fine tune your body model until you&#39;re happy with
                        the result.{" "}
                        <a
                            href="https://www.mybodymodel.com/faq/top-5-troubleshooting-tips-for-creating-a-body-model-that-youll-love/"
                            target="_blank"
                        >
                            Here are some tips
                        </a>{" "}
                        for fixing some common issues and errors. If something
                        isn&#39;t working correctly, please let us know!
                    </p>
                    <p>
                        Email{" "}
                        <a href="mailto:help@mybodymodel.com">
                            help@mybodymodel.com
                        </a>{" "}
                        with a detailed description, including a screenshot if
                        possible. Thank you!
                    </p>
                </div>
                <TransactionDialog />
                <DeleteConfirmDialog
                    dialogOpen={isDeleteConfirmDialogOpen}
                    dialogClose={this.handleCloseDeleteConfirmDialog}
                    onDelete={() => onDeleteClick(croquis.id)}
                    croquis={croquis}
                />
                <WhatsIncludedDialog />
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/body-model-preview/components/BodyModelPreview.js